import { AfterViewInit, Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ColorDTO } from '../../../../shared/models/model';
import { NotificationService } from 'src/app/shared/service/notification.service';
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { LocalDataSource } from 'ng2-smart-table';
import Swal from 'sweetalert2';
import { colorService } from 'src/app/shared/service/color.service';

@Component({
  selector: 'app-color',
  templateUrl: './color.component.html',
  styleUrls: ['./color.component.scss']
})
export class ColorComponent implements OnInit {
  public closeResult: string;
  public colorsList: ColorDTO[]=[];
  public Color: ColorDTO = new ColorDTO();
  public Source:LocalDataSource;


  constructor(private modalService: NgbModal, private backService: colorService, private notifcationService: NotificationService, private toastr: ToastrService) {
    this.Source = new LocalDataSource();
    this.backService.getColors().subscribe(data => {
      this.colorsList = data;
      this.Source = new LocalDataSource(this.colorsList);
  });

    console.log(this.Source);
  }

  open(content) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }


  updateRecord(event) {
    this.Color.description = event.newData.description;
    this.Color.idColor = event.data["idcolor"];
    this.backService.updateColor(this.Color);
    event.confirm.resolve(event.newData);
  }

  deleteRecord(event) {
    debugger
    Swal.fire({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        console.log("test");
        this.Color = new ColorDTO();
        this.Color.idColor = event.data.idColor;
        this.backService.deleteColor(event.data.idcolor);
        event.confirm.resolve(event.newData);

        Swal.fire(
          'Deleted!',
          'Your file has been deleted.',
          'success'
        );
      }
    });


    
    
          
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


  public settings = {
    "mode": "inline",
    delete: {
      "confirmDelete": "true"
    },
    edit: { "confirmSave": "true" },
    actions: {
      position: 'right',
      update: true
    },
    columns: {
      idcategory: {
        title: 'Idcategory'
      },
      description: {
        title: 'Description'
      }
    },
  };
  ngOnInit() {
    this.Source = new LocalDataSource();
    this.loadGrid();
  }

  loadGrid() {
    this.backService.getColors().subscribe(data => {
      this.colorsList = data;
      this.Source = new LocalDataSource(this.colorsList);
      this.Source.refresh();
  });
  }


  onSubmit(contactForm) {
    this.Source.refresh();
    debugger
    console.log("submit");
    this.Color = new ColorDTO();
    this.Color.description = contactForm.value["Description"];
    this.backService.addColor(this.Color);
    window.location.reload();
  }



}
function collapseAnimation() {
  throw new Error('Function not implemented.');
}

